import 'reflect-metadata'

import { Expose } from 'class-transformer'

import { Board } from '../model/Board'

export class BoardEntity {
  /**
   * Board unique identifier
   */
  @Expose()
  public id: string

  /**
   * Community cards on the table for this Board
   */
  @Expose()
  public communityCards: string[]

  /**
   * Count of chips in the main pot
   */
  @Expose()
  public mainPot: number

  /**
   * Current big blind size
   */
  @Expose()
  public bigBlindAmount: number

  /**
   * Current small blind size
   */
  @Expose()
  public smallBlindAmount: number

  /**
   * Board current state
   */
  @Expose()
  public state: string

  /**
   * Default BoardEntity
   * @param partial BoardEntity to construct from partial
   */
  constructor(partial: Partial<BoardEntity>) {
    this.id = ''
    this.communityCards = []
    this.mainPot = 0
    this.bigBlindAmount = 100
    this.smallBlindAmount = 50
    this.state = ''
    Object.assign(this, partial)
  }

  /**
   * Creates a new BoardEntity from the given reference board
   *
   * @param board reference board to make entity
   * @returns
   */
  static createFromBoard(board: Board) {
    if (!board) {
      return
    }

    return <BoardEntity>{
      id: board.id,
      communityCards: board.communityCards,
      mainPot: board.pot.amount,
      bigBlindAmount: board.blinds ? board.blinds.big : undefined,
      smallBlindAmount: board.blinds ? board.blinds.small : undefined,
      state: board.internalState()
    }
  }
}
